import {kickSession} from '../sessionBusiness';
import {SignalREvent, ViewMode} from '../../../constants/dataEnum';

export const subscribeEvent = (hubObject) => (dispatch, getState) => {
  hubObject.on(SignalREvent.HEARTBEAT, (args) => {
    console.info('event received:', SignalREvent.HEARTBEAT);
    console.log(SignalREvent.HEARTBEAT, args);
  });

  hubObject.on(SignalREvent.SESSION_CHANGED, (args) => {
    console.info('event received:', SignalREvent.SESSION_CHANGED);
    console.log(SignalREvent.SESSION_CHANGED, args);

    const state = getState();
    const {appState, sessionState} = state;
    const {sessionId, user} = sessionState;
    const {userId} = user;

    if (appState.viewMode === ViewMode.LOGIN) {
      return;
    }

    if (userId !== args.userId) {
      return;
    }

    if (sessionId === args.sessionId) {
      return;
    }

    dispatch(kickSession());
  });
};

export default subscribeEvent;
